import React, { useImperativeHandle, useState, useCallback } from 'react'
import ReactDom from 'react-dom'
import { ForwardRefRenderFunction } from 'react'
import './toast.css'

function ResolveIcon(props) {
  return (
    <Svg {...props} viewBox='0 0 24 24'>
      <path d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm4.3 7.61l-4.57 6a1 1 0 0 1-.79.39 1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08 3.78-5a1 1 0 1 1 1.6 1.22z' />
    </Svg>
  )
}

function Svg({
  size = 128,
  color = '#000',
  rotate = 0,
  viewBox = null,
  className = '',
  style = {},
  onClick = null,
  children
}: any) {

  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 1024 1024'}
      style={{ ...style, transform: `${style.transform || ''} rotate(${rotate || 0}deg)` }}
      onClick={onClick}
      width={size}
      height={size}
      fill={color}
    >
      {children}
    </svg>
  )
}

function CloseIcon(props) {
  return (
    <Svg {...props} viewBox='0 0 48 48'>
      <path d='M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.8-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.72 7.723c-.727.728-.56 1.646-.066 2.177.493.532 1.553.683 2.31-.174l7.588-7.584 7.644 7.623c.796.798 1.608.724 2.21.145.605-.58.72-1.442-.074-2.24l-7.657-7.67 7.545-7.52c.81-.697.9-1.76.297-2.34-.92-.885-1.85-.338-2.264.078l-7.685 7.667z' fillRule='evenodd' />
    </Svg>
  )
}

function render<T>(
  Component: ForwardRefRenderFunction<T, any>, //  要插入的组件
  className: string | undefined  // 插入在body下的div的名字
): T {
  const ref = React.createRef() as React.MutableRefObject<T>
  const dom = document.createElement('div')
  if (className) dom.className = className
  document.body.appendChild(dom)
  ReactDom.render(<Component ref={ref} />, dom)
  return ref.current
}

enum MSGTYPE {
  INFO,
  FAIL
}

interface IToastRef {
  info: (msg: any) => void,
  error: (msg: any) => void
}

interface IList {
  type: MSGTYPE,
  id: number
  msg: string | any
}

let cache: (IList | null)[] = []
let timer: number | null = null

function Toast(_: null, ref: any) {

  const [ list, setList ] = useState<(IList | null)[]>(cache)

  const addNoice = useCallback((item: IList) => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }

    const ullage = cache.length
    const _list = [ ...cache ]
    const msg = item.msg
    _list.push({ ...item, msg: typeof msg === 'string' ? msg : JSON.stringify(msg) })
    setList(_list)
    cache = _list

    setTimeout(() => {
      cache[ullage] = null
      setList(cache)
    }, 2000)

    timer = window.setTimeout(() => {
      cache = []
      setList(cache)
    }, 2500)
  }, [])

  useImperativeHandle<any, IToastRef>(ref, () => ({
    info(msg) {
      addNoice({ type: MSGTYPE.INFO, msg, id: new Date().getTime() + Math.random() })
    },
    error(msg) {
      addNoice({ type: MSGTYPE.FAIL, msg, id: new Date().getTime() + Math.random() })
    }
  }))

  return (
    <>
      {
        list.map(item => {
          if (item) return <Notice
            key={item.id}
            {...item}
          />
          return null
        })
      }
    </>
  )
}

function Notice({ msg, type }: IList) {
  return <div
    className='b-fx b-j-c b-notice-item b-bg-fff'
    style={{
      // transform:         'translateY(0px)',
      // opacity:           1,
      transform:         'translateY(-50px)',
      animation:         'bweb-toast-animation 2.5s',
      animationFillMode: 'forwards',
      opacity:           0,
      boxShadow:         '0px 5px 10px 0px rgba(0, 0, 0, .1)',
      zIndex:            99,
      margin:            5,
      padding:           5,
      borderRadius:      6
    }}
  >
    <div className='b-fx b-j-c' style={{ flexShrink: 0, width: 35, height: 28 }}>
      {type === MSGTYPE.INFO ? <ResolveIcon size={25} color='#53C41A' /> : <CloseIcon size={20} color='#F5232F' />}
    </div>
    <span style={{ fontSize: 15, lineHeight: '25px' }}>{msg}</span>
  </div>
}

export default render<IToastRef>((React.forwardRef(Toast) as any), 'bweb-toast b-fx b-fx-col b-fd b-ck-ne')